<!--
  File name: AdminDashboard.vue
  Program Description:
    - This is container component for the Landing page in Dashboard

  Includes:
    - Landing
-->
<template>
  <v-container
    fluid
    pa-0
    class="landing"
    style="height: 100%"
  >
    <Landing
      class="landing--width"
      :full-name="currentUser.fullName"
      :is-pic="isPic"
      :header="header"
      :description="description"
      :card-image="$metaData.app.landingPage"
    />
  </v-container>
</template>

<script>
import landingPage from '../../meta/landingPage'
import Landing from './selfAssessmentForm/Landing'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminDashboard',
  components: {
    Landing
  },
  computed: {
    ...mapGetters('lookups', {
      currentUser: 'getCurrentUser'
    }),
    header () {
      return landingPage.header
    },
    description () {
      return landingPage.description
    },
    isPic () {
      return this.$s.userRole.includes('pic')
    }
  }
}
</script>

<style>
  .landing {
    font-family: 'Roboto';
  }

  .landing--width {
    width: 95%;
  }
</style>
